import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http'
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root'
})
export class LocationsService {

  constructor(private http : HttpClient,public dialog : MatDialog,private snackbar : MatSnackBar) { }

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 1500 });
  }

  openDeleteDialog(componentName: any, height: any, width: any, dataModel: any, maxwidth: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: maxwidth,
    });
  }

  openDialog(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
    });
  }

    // for listing in location country 
    getCountryList(page:number,size:number){
      return this.http.get(
        environment.baseUrl+`admin/master/location/country?pageNo=${page}&size=${size}`
      )
    }
  
    getActiveInActiveCountryCount(){
      return this.http.get(
        environment.baseUrl+`admin/master/location/country/active/inactive`
      )
    }
  
    // for search country in template 
    getSearchCountry(page:number,size:number,searchText:any){
      return this.http.get(
        environment.baseUrl+`admin/master/location/country/search?pageNo=${page}&size=${size}&text=${searchText}`
      )
    }
    
  
    // for add country in template 
    addCountry(data:any){
      return this.http.post(
        environment.baseUrl+`admin/master/location/country`,data
      )
    }
    // for add country in template 
    updateCountry(data:any){
      return this.http.put(
        environment.baseUrl+`admin/master/location/country`,data
      )
    }
    deleteCountry(countryId:any){
      return this.http.delete(
        environment.baseUrl+`admin/master/location/country?id=${countryId}`
      )
    }

    changeToggleCountry(status: any , countryId: any  ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/country/status?active=${status}&id=${countryId}`,{}
      )
    }

    countryFilter(status:any , pageNo:any ,size:any ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/country/filter?active=${status}&pageNo=${pageNo}&size=${size}`,{}
      )
    }
    
    
   
     // for listing in location state 
     getStateList(page:number,size:number){
      return this.http.get(
        environment.baseUrl+`admin/master/location/state?pageNo=${page}&size=${size}`
      )
    }
    getActiveStateListByCountry(data:any){
      return this.http.put(
        environment.baseUrl+`admin/master/location/state/filter`,data
      )
    }
  
    // for search country in template 
    getSearchState(page:number,size:number,searchText:any){
      return this.http.get(
        environment.baseUrl+`admin/master/location/state/search?pageNo=${page}&size=${size}&text=${searchText}`
      )
    }
    getActiveInActiveStateCount(){
      return this.http.get(
        environment.baseUrl+`admin/master/location/state/active/inactive`
      )
    }
  
    // for add country in template 
    addState(data:any){
      return this.http.post(
        environment.baseUrl+`admin/master/location/state`,data
      )
    }
     // for add country in template 
     updateState(data:any){
      return this.http.put(
        environment.baseUrl+`admin/master/location/state`,data
      )
    }
    deleteState(stateId:any){
      return this.http.delete(
        environment.baseUrl+`admin/master/location/state?id=${stateId}`
      )
    }
    changeToggleState(status: any , countryId: any  ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/state/status?active=${status}&id=${countryId}`,{}
      )
    }

    stateFilter(data:any){
      return this.http.put(
        environment.baseUrl +`admin/master/location/state/filter`,data
      )
    }

    // for listing in location city 
    getCityList(page:number,size:number){
      return this.http.get(
        environment.baseUrl+`admin/master/location/city?pageNo=${page}&size=${size}`
      )
    }
    getActiveInActiveCityCount(){
      return this.http.get(
        environment.baseUrl+`admin/master/location/city/active/inactive`
      )
    }
    // for search country in template 
    getSearchCity(page:number,size:number,searchText:any){
      return this.http.get(
        environment.baseUrl+`admin/master/location/city/search?pageNo=${page}&size=${size}&text=${searchText}`
      )
    }
  
    // for add country in template 
    addCity(data:any){
      return this.http.post(
        environment.baseUrl+`admin/master/location/city`,data
      )
    }
    updateCity(data:any){
      return this.http.put(
        environment.baseUrl+`admin/master/location/city`,data
      )
    }
    deleteCity(cityId:any){
      return this.http.delete(
        environment.baseUrl+`admin/master/location/city?id=${cityId}`
      )
    }
    changeToggleCity(status: any , countryId: any  ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/city/status?active=${status}&id=${countryId}`,{}
      )
    }
    cityFilter(data:any){
      return this.http.put(
        environment.baseUrl +`admin/master/location/city/filter`,data
      )
    }

    // for listing in location locality 
    getLocalityList(page:number, size:number){
      return this.http.get(
        environment.baseUrl+`admin/master/location/locality?pageNo=${page}&size=${size}`
      )
    }
    getActiveInActiveLocalityCount(){
      return this.http.get(
        environment.baseUrl+`admin/master/location/locality/active/inactive`
      )
    }
    // for search country in template 
    getSearchLocality(page:number,size:number,searchText:any){
      return this.http.get(
        environment.baseUrl+`admin/master/location/locality/search?pageNo=${page}&size=${size}&text=${searchText}`
      )
    }
  
    // for add country in template 
    addLocality(data:any){
      return this.http.post(
        environment.baseUrl+`admin/master/location/locality`,data
      )
    }

    updateLocality(data:any){
      return this.http.put(
        environment.baseUrl+`admin/master/location/locality`,data
      )
    }
    deleteLocality(localityId:any){
      return this.http.delete(
        environment.baseUrl+`admin/master/location/locality?id=${localityId}`
      )
    }
    changeToggleLocality(status: any , countryId: any  ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/locality/status?active=${status}&id=${countryId}`,{}
      )
    }

    localityFilter(data:any){
      return this.http.put(
        environment.baseUrl +`admin/master/location/locality/filter`,data
      )
    }
}
